/* tslint:disable */
/* eslint-disable */
/**
 * Token.WebApi v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {CoordinatesDto} from './CoordinatesDto';
import {
  CoordinatesDtoFromJSON,
  CoordinatesDtoFromJSONTyped,
  CoordinatesDtoToJSON,
  CoordinatesDtoToJSONTyped,
} from './CoordinatesDto';
import type {EventOccurrenceDto} from './EventOccurrenceDto';
import {
  EventOccurrenceDtoFromJSON,
  EventOccurrenceDtoFromJSONTyped,
  EventOccurrenceDtoToJSON,
  EventOccurrenceDtoToJSONTyped,
} from './EventOccurrenceDto';
import type {AddressDto} from './AddressDto';
import {
  AddressDtoFromJSON,
  AddressDtoFromJSONTyped,
  AddressDtoToJSON,
  AddressDtoToJSONTyped,
} from './AddressDto';

/**
 *
 * @export
 * @interface EventDetailDto
 */
export interface EventDetailDto {
  /**
   *
   * @type {string}
   * @memberof EventDetailDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof EventDetailDto
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof EventDetailDto
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof EventDetailDto
   */
  locationCode: number;
  /**
   *
   * @type {AddressDto}
   * @memberof EventDetailDto
   */
  address: AddressDto;
  /**
   *
   * @type {string}
   * @memberof EventDetailDto
   */
  groupId?: string | null;
  /**
   *
   * @type {Array<EventOccurrenceDto>}
   * @memberof EventDetailDto
   */
  occurrences: Array<EventOccurrenceDto>;
  /**
   *
   * @type {Array<string>}
   * @memberof EventDetailDto
   */
  photoUrls: Array<string>;
  /**
   *
   * @type {CoordinatesDto}
   * @memberof EventDetailDto
   */
  coordinates: CoordinatesDto;
  /**
   *
   * @type {Array<number>}
   * @memberof EventDetailDto
   */
  tagCodes: Array<number>;
  /**
   *
   * @type {Array<string>}
   * @memberof EventDetailDto
   */
  mapImageCdnPaths: Array<string>;
  /**
   *
   * @type {string}
   * @memberof EventDetailDto
   */
  mapUri: string;
}

/**
 * Check if a given object implements the EventDetailDto interface.
 */
export function instanceOfEventDetailDto(
  value: object,
): value is EventDetailDto {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined)
    return false;
  if (!('locationCode' in value) || value['locationCode'] === undefined)
    return false;
  if (!('address' in value) || value['address'] === undefined) return false;
  if (!('occurrences' in value) || value['occurrences'] === undefined)
    return false;
  if (!('photoUrls' in value) || value['photoUrls'] === undefined) return false;
  if (!('coordinates' in value) || value['coordinates'] === undefined)
    return false;
  if (!('tagCodes' in value) || value['tagCodes'] === undefined) return false;
  if (!('mapImageCdnPaths' in value) || value['mapImageCdnPaths'] === undefined)
    return false;
  if (!('mapUri' in value) || value['mapUri'] === undefined) return false;
  return true;
}

export function EventDetailDtoFromJSON(json: any): EventDetailDto {
  return EventDetailDtoFromJSONTyped(json, false);
}

export function EventDetailDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EventDetailDto {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    description: json['description'],
    locationCode: json['locationCode'],
    address: AddressDtoFromJSON(json['address']),
    groupId: json['groupId'] == null ? undefined : json['groupId'],
    occurrences: (json['occurrences'] as Array<any>).map(
      EventOccurrenceDtoFromJSON,
    ),
    photoUrls: json['photoUrls'],
    coordinates: CoordinatesDtoFromJSON(json['coordinates']),
    tagCodes: json['tagCodes'],
    mapImageCdnPaths: json['mapImageCdnPaths'],
    mapUri: json['mapUri'],
  };
}

export function EventDetailDtoToJSON(json: any): EventDetailDto {
  return EventDetailDtoToJSONTyped(json, false);
}

export function EventDetailDtoToJSONTyped(
  value?: EventDetailDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    name: value['name'],
    description: value['description'],
    locationCode: value['locationCode'],
    address: AddressDtoToJSON(value['address']),
    groupId: value['groupId'],
    occurrences: (value['occurrences'] as Array<any>).map(
      EventOccurrenceDtoToJSON,
    ),
    photoUrls: value['photoUrls'],
    coordinates: CoordinatesDtoToJSON(value['coordinates']),
    tagCodes: value['tagCodes'],
    mapImageCdnPaths: value['mapImageCdnPaths'],
    mapUri: value['mapUri'],
  };
}
